import { useEffect } from "react";
import { SITE_URL } from "@/lib/api";

let started = false;

const showError = () => {
  document.body.innerHTML =
    '<p style="font-family:sans-serif;padding:40px">HOGASEARCH Spain – please reload the page.</p>';
};

export default function PublicPage() {
  useEffect(() => {
    if (started) return;
    started = true;
    const { pathname, search, hash } = window.location;
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
    if (path !== pathname) window.history.replaceState(null, "", path + search + hash);
    fetch(`${SITE_URL}/api/site${path}${search}`)
      .then((r) => r.text())
      .then((html) => {
        document.open();
        document.write(html);
        document.close();
      })
      .catch(showError);
  }, []);
  return <div data-testid="public-page-loading" style={{ minHeight: "100vh", background: "#F7F4EF" }} />;
}
